$ = require 'jquery'
Confirm = require 'app/scripts/views/lib/confirm'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
t = require('teacup')
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
xtend = require 'xtend'

template = t.renderable (entries) ->
  t.ul '.pop-over-list', ->
    for { name, url, id } in entries
      t.li ->
        t.a '.js-remove', { 'data-id-attachment': id }, ->
          t.text name
          return
        return
    return
  return

module.exports = class PluginSectionRemoveAttachmentsView extends View
  viewTitleKey: 'remove attachments'

  initialize: ({ section }) ->
    @section = section

  events:
    'click .js-remove': 'confirmRemove'

  renderOnce: ->
    board = @model.getBoard()
    card = @model

    Promise.map @section.claimed, (claim) ->
      PluginRunner.one
        command: 'format-url'
        board: board
        card: card
        options:
          url: claim.url
      .get('text')
      .catch PluginRunner.Error.NotHandled, ->
        claim.name || claim.url
      .then (name) ->
        xtend claim, { name }

    .then (claimed) =>
      @$el.html(template(claimed))
    @

  confirmRemove: (e) ->
    Util.stop(e)

    idAttachment = $(e.currentTarget).attr('data-id-attachment')
    model = @model.attachmentList.get(idAttachment)

    Confirm.pushView 'remove attachment',
      model: model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        model.destroy()
        track("Attachment", "Delete Attachment", model.getType())
